import { ParamMap } from '@angular/router';

/**
 * Helpers for keeping a list page's filters in the URL. Keys must be
 * lowercase: the admin app's LowerCaseUrlSerializer lowercases the whole URL,
 * values included, so values come back lowercased too.
 */

/** A '' / 'true' / 'false' select value from the URL, else the fallback. */
export function triState(params: ParamMap, key: string, fallback: '' | 'true' | 'false' = ''): '' | 'true' | 'false' {
  const v = params.get(key);
  return v === 'true' || v === 'false' || v === '' ? v : fallback;
}

/** A positive integer id from the URL, or undefined. */
export function idParam(params: ParamMap, key: string): number | undefined {
  const n = Number(params.get(key));
  return Number.isInteger(n) && n > 0 ? n : undefined;
}

/** Query params for router.navigate: a value equal to its default, or empty, becomes null so the key drops out. */
export function withoutDefaults(
  values: Record<string, string | number | undefined | null>,
  defaults: Record<string, string | number | undefined | null> = {},
): Record<string, string | number | null> {
  const out: Record<string, string | number | null> = {};
  for (const [key, value] of Object.entries(values)) {
    const empty = value === undefined || value === null || value === '';
    out[key] = empty || value === defaults[key] ? null : value;
  }
  return out;
}
